"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEW_OFFLINE_ORDER = void 0;
var NEW_OFFLINE_ORDER = {
  LABEL__MODAL_UPLOAD_INVOICE: 'logOfflineOrderNewSupplierFlow-label-uploadInvoice',
  BUTTON__MODAL_CANCEL: 'logOfflineOrderNewSupplierFlow-button-cancel',
  BUTTON__MODAL_CONFIRM: 'pendingUpdates-button-logOrder'
};
exports.NEW_OFFLINE_ORDER = NEW_OFFLINE_ORDER;